import React from 'react';
import Modal from '@roo/roo/Modal';

const openSignProtocolModal = (type: string) => {
    Modal.confirm({
        title: '发配送失败',
        closable: true,
        cancelText: '我知道了',
        confirmText: '去看看',
        onConfirm: () => {
            // eslint-disable-next-line waimaie/no-direct-change-parent-location
            parent.location.href = '/promise';
        },
        children: (
            <div>{`由于您未在7天内确认${type}配送补充协议，已无法再使用${type}配送服务，请尽快前往处理`}</div>
        ),
    });
};

export default openSignProtocolModal;
